module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAcUlEQVR42u3aQQ0AMAwDsUDac3wHNAMSVzoCflVq0zbLBQAAAAAAAAAAAACAcYB3bpcCAAAAAAAAAAAAAAAAAAAAADTdGwAAAAAAAACARQgAAAAAAAAAAAAAAAAAAABYvgv4FAUAAAAAAAAAAAAAYKcPE3SSF47xF50AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Latvia.png
// module id = Lp5r
// module chunks = 0 62 63